import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
import Overview from 'src/pages/Company/Overview.vue'
import Stats from 'src/components/Dashboard/Views/Dashboard/Stats.vue'

// Pages
import Layout from 'src/pages/Company/Index'

import Dashboard from 'src/pages/Company/Dashboard/Index'
import Facebook from 'src/pages/Company/Dashboard/Social/Facebook'
import Twitter from 'src/pages/Company/Dashboard/Social/Twitter'
import Instagram from 'src/pages/Company/Dashboard/Social/Instagram'
import Website from 'src/pages/Company/Dashboard/Social/Website'

import User from 'src/pages/Company/User/Index.vue'
import UserProfile from 'src/pages/Company/User/Profile.vue'
import UserSettings from 'src/pages/Company/User/Settings.vue'

import Product from 'src/pages/Company/Product/Index.vue'
import ProductAdd from 'src/pages/Company/Product/Add.vue'
import ProductList from 'src/pages/Company/Product/List.vue'
import ProductStats from 'src/pages/Company/Product/Stats.vue'

import Store from 'src/pages/Company/Store/Index.vue'
import StoreAdd from 'src/pages/Company/Store/Add.vue'
import StoreEdit from 'src/pages/Company/Store/Edit.vue'
import StoreView from 'src/pages/Company/Store/View.vue'
import StoreList from 'src/pages/Company/Store/List.vue'
import StoreStats from 'src/pages/Company/Store/Stats.vue'

import Order from 'src/pages/Company/Order/Index.vue'
import OrderList from 'src/pages/Company/Order/List.vue'
import OrderDetails from 'src/pages/Company/Order/Details.vue'

import View from 'src/pages/Company/View.vue'

import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue'
import Login from 'src/pages/Login.vue'
import Register from 'src/pages/Register.vue'
import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'
import LoadCompany from 'src/pages/LoadCompany.vue'

// Components pages
import Buttons from 'src/components/Dashboard/Views/Components/Buttons.vue'
import GridSystem from 'src/components/Dashboard/Views/Components/GridSystem.vue'
import Panels from 'src/components/Dashboard/Views/Components/Panels.vue'
import SweetAlert from 'src/components/Dashboard/Views/Components/SweetAlert.vue'
import Notifications from 'src/components/Dashboard/Views/Components/Notifications.vue'
import Icons from 'src/components/Dashboard/Views/Components/Icons.vue'
import Typography from 'src/components/Dashboard/Views/Components/Typography.vue'

// Forms pages
import RegularForms from 'src/components/Dashboard/Views/Forms/RegularForms.vue'
import ExtendedForms from 'src/components/Dashboard/Views/Forms/ExtendedForms.vue'
import ValidationForms from 'src/components/Dashboard/Views/Forms/ValidationForms.vue'
import Wizard from 'src/components/Dashboard/Views/Forms/Wizard.vue'

// TableList pages
import RegularTables from 'src/components/Dashboard/Views/Tables/RegularTables.vue'
import ExtendedTables from 'src/components/Dashboard/Views/Tables/ExtendedTables.vue'
import PaginatedTables from 'src/components/Dashboard/Views/Tables/PaginatedTables.vue'
// Maps pages
import GoogleMaps from 'src/components/Dashboard/Views/Maps/GoogleMaps.vue'
import FullScreenMap from 'src/components/Dashboard/Views/Maps/FullScreenMap.vue'
import VectorMaps from 'src/components/Dashboard/Views/Maps/VectorMapsPage.vue'

// Calendar
// import Calendar from 'src/components/Dashboard/Views/Calendar/CalendarRoute.vue'
// Charts
// import Charts from 'src/components/Dashboard/Views/Charts.vue'

let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'panels',
      name: 'Panels',
      component: Panels
    },
    {
      path: 'sweet-alert',
      name: 'Sweet Alert',
      component: SweetAlert
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }

  ]
}

let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Forms',
      component: RegularForms
    },
    {
      path: 'extended',
      name: 'Extended Forms',
      component: ExtendedForms
    },
    {
      path: 'validation',
      name: 'Validation Forms',
      component: ValidationForms
    },
    {
      path: 'wizard',
      name: 'Wizard',
      component: Wizard
    }
  ]
}

let tablesMenu = {
  path: '/table-list',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Tables',
      component: RegularTables
    },
    {
      path: 'extended',
      name: 'Extended Tables',
      component: ExtendedTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }]
}

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'full-screen',
      name: 'Full Screen Map',
      component: FullScreenMap
    },
    {
      path: 'vector-map',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
}

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  redirect: '/pages/user',
  children: [
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
}

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

const routes = [
  {
    path: '/',
    component: LoadCompany,
    meta: {
      requiresAuth: true
    }
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  loginPage,
  registerPage,
  lockPage,
  {
    path: '/:company',
    component: Layout,
    redirect: '/:company/dashboard',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'stats',
        name: 'Stats',
        component: Stats
      },
      // {
      //   path: 'users/:user',
      //   name: 'User',
      //   component: User
      // },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        children: [
          {
            path: 'facebook',
            name: 'Facebook',
            component: Facebook
          },
          {
            path: 'instagram',
            name: 'Instagram',
            component: Instagram
          },
          {
            path: 'twitter',
            name: 'Twitter',
            component: Twitter
          },
          {
            path: 'website',
            name: 'Website',
            component: Website
          }
        ]
      },
      {
        path: 'profile',
        name: 'Profile',
        redirect: 'ProfileEdit',
        component: User,
        children: [
          {
            path: 'edit',
            name: 'ProfileEdit',
            component: UserProfile
          },
          {
            path: 'settings',
            name: 'ProfileSettings',
            component: UserSettings
          }
        ]
      },
      {
        path: 'product',
        name: 'Product',
        redirect: 'ProductList',
        component: Product,
        children: [
          {
            path: 'add',
            name: 'ProductAdd',
            component: ProductAdd
          },
          {
            path: 'list',
            name: 'ProductList',
            component: ProductList
          },
          {
            path: 'stats',
            name: 'ProductStats',
            component: ProductStats
          }
        ]
      },
      {
        path: 'store',
        name: 'Store',
        redirect: 'StoreList',
        component: Store,
        children: [
          {
            path: 'add',
            name: 'StoreAdd',
            component: StoreAdd
          },
          {
            path: 'edit',
            name: 'StoreEdit',
            component: StoreEdit
          },
          {
            path: 'list',
            name: 'StoreList',
            component: StoreList
          },
          {
            path: 'stats',
            name: 'StoreStats',
            component: StoreStats
          },
          {
            path: 'view/:store',
            name: 'StoreView',
            component: StoreView
          }
        ]
      },
      {
        path: 'order',
        name: 'Order',
        redirect: 'OrderList',
        component: Order,
        children: [
          {
            path: 'list',
            name: 'OrderList',
            component: OrderList
          },
          {
            path: ':order_id',
            name: 'OrderDetails',
            component: OrderDetails
          }
        ]
      },
      {
        path: 'view',
        name: 'View',
        component: View
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {path: '*', component: NotFound}
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js